import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState, } from "react";
import { Button } from "@mui/material";
export const SubmissionButton = (props) => {
    const [submitting, setSubmitting] = useState(false);
    const handleClick = useCallback((event) => {
        const runAsync = async () => {
            // Don't allow a second concurrent submission
            if (submitting) {
                event.preventDefault();
                return;
            }
            // Block any further clicks until the current submission is done
            setSubmitting(true);
            try {
                // Await the handler to complete
                await props.onClick?.(event);
            }
            finally {
                setSubmitting(false);
            }
        };
        void runAsync();
    }, [props, submitting]);
    return (_jsx(Button, { ...props, disabled: submitting || props.disabled, onClick: handleClick }));
};
//# sourceMappingURL=SubmissionButton.js.map